// eslint-disable-next-line no-restricted-imports
import { LegalClientLegalAddressFragment } from 'api/generated/graphql';
import { parseFileDocumentEntity } from 'api/helpers/client/parseEntity/parseFileEntity';
import { LegalClientLegalAddressEntity } from 'api/types/entity';
import { lodash } from 'helpers';
import { Maybe } from 'types/maybe';

export const parseLegalClientLegalAddressEntity = (
  data?: Maybe<LegalClientLegalAddressFragment>
): LegalClientLegalAddressEntity | undefined => {
  if (!data) {
    return undefined;
  }

  const { confirmationDocuments, ...rest } = data;

  const res: LegalClientLegalAddressEntity = {
    ...rest,
    confirmationFiles: lodash
      .compact(confirmationDocuments)
      .map(parseFileDocumentEntity),
  };

  return res;
};
